import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export async function getStudentDiagnosticAttempts(studentId) {
  if (!studentId) return [];

  const q = query(
    collection(db, "users", studentId, "diagnosticAttempts"),
    orderBy("createdAt", "desc")
  );

  const snap = await getDocs(q);

  return snap.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }));
}
